import { SET_USER_TYPE_ACTION } from "./reducersConstants";

export const setUserTypeAction = (data) => {
  return {
    type: SET_USER_TYPE_ACTION,
    data,
  };
};

export const userTypeReducer = (previousState = null, { type, data }) => {
  switch (type) {
    case SET_USER_TYPE_ACTION:
      return data;
    default:
      return previousState;
  }
};
